import React from 'react';
import block from 'bem-cn-lite';
import {Text, Tooltip} from '@gravity-ui/uikit';

import './DeliveryDays.scss';

const b = block('delivery-days');

export interface DeliveryDaysProps {
    value: number;
    className?: string;
    triggerClassName?: string;
    maxValue?: number;
    withTooltip?: boolean;
}

export const DeliveryDays: React.FC<DeliveryDaysProps> = (props) => {
    const showRange = props.maxValue !== undefined;

    const textContent = (
        <Text
            variant={'body-1'}
            className={props.triggerClassName}
            style={
                props.withTooltip
                    ? {
                          textDecoration: 'underline',
                          textDecorationStyle: 'solid',
                          textUnderlineOffset: '25%',
                          textDecorationThickness: '5%'
                      }
                    : undefined
            }
        >
            {showRange ? `${props.value}-${props.maxValue}` : `${props.value}`}
        </Text>
    );

    return (
        <div className={`${b(null, props.className)}`}>
            {props.withTooltip ? (
                <Tooltip
                    content={
                        <Text variant={'body-1'}>Здесь везём издалека. Указан min и max срок</Text>
                    }
                    contentClassName={b('delivery-days-tooltip')}
                    className={b('delivery-days-tooltip-container')}
                    placement={'top'}
                    openDelay={0}
                    closeDelay={0}
                    disabled={false}
                >
                    {textContent}
                </Tooltip>
            ) : (
                textContent
            )}
        </div>
    );
};
